<template>

  <div id="app">

    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>

      <v-card color="grey lighten-4" flat>

        <v-layout row wrap>

          <v-flex xs12 md12 sm12>

            <v-toolbar size="120px" dark color="info">

              <v-toolbar-title> {{ $t('Analysis-Report') }}</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet" :label="$t('Search')"

                append-icon="search"></v-text-field>

                <v-btn color="pink lighten-1" dark @click="openMailDialog" small>

  <v-icon left>email</v-icon> Mail Gönder

</v-btn>

              <v-menu bottom="" left>

                <v-btn slot="activator" dark icon>

                  <v-icon>more_vert</v-icon>

                </v-btn>

                <v-list>

                  <v-list-tile @click="getListHtml()">

                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>

                  </v-list-tile>



                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">

                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>

                  </v-list-tile>

                </v-list>

              </v-menu>

            </v-toolbar>

          </v-flex>

<!-- MAIL GÖNDER DIALOG -->

<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>

  <v-card>

    <v-toolbar dense flat color="info" dark>

      <v-toolbar-title>Mail Gönder</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>

    </v-toolbar>

    <v-card-text>

      <v-form ref="mailForm" v-model="mailValid" lazy-validation>

        <v-layout wrap>

          <v-flex xs12>

            <v-text-field

              v-model="mailPayload.To"

              label="Kime (e-posta)"

              :rules="[rules.required, rules.email]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgencyName"

              label="Agency Name"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.DocType"

              label="Doc Type (sabit)"

              :rules="[rules.required]"

              :disabled="true"

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgentFullName"

              label="Agent Full Name"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12>

            <v-textarea

              v-model="mailPayload.CustomBody"

              label="Mesaj"

              :rules="[rules.required]"

              auto-grow

              rows="3"

            ></v-textarea>

          </v-flex>

        </v-layout>

      </v-form>

    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>

      <v-spacer></v-spacer>

      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>

      <v-btn

        color="info"

        :loading="mailLoading"

        :disabled="!mailValid || mailLoading"

        @click="sendMail"

      >

        <v-icon left>send</v-icon>Gönder

      </v-btn>

    </v-card-actions>

  </v-card>

</v-dialog>

          <v-container fluid>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>

              <v-layout row wrap>

                <v-flex pb-3 xs12 sm12 md12>

                  <v-card flat>

                    <v-layout row wrap>

                      <v-flex xs12 sm6 pt-2 md2>

                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"

                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"

                          v-bind:value="Rapor.BaslangicTarih" v-model="Rapor.BaslangicTarih"></tarihcomp>

                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>

                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"

                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"

                          v-bind:value="Rapor.BitisTarih" v-model="Rapor.BitisTarih"></tarihcomp>

                      </v-flex>

                      <v-flex xs12 pt-2 sm2 md2>

                              <analizcomp :etiket="$t('Analysis-Code')" :v-bind:hd="true" :rules="[v => !!v || $t('Please-select-the-analysis-code')]" v-model="Rapor.AnalizKodu"></analizcomp>

                            </v-flex>





                      <v-flex pt-2>

                        <v-layout>

                          <div v-if="load1">

                            <v-btn color="info" @click="getList()" fab small="" dark>

                              <v-icon>search</v-icon>

                            </v-btn>

                          </div>

                          <div v-if="progress">

                            <v-layout pt-3 align-center="">

                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>

                            </v-layout>

                          </div>

                            <v-badge color="white"  :overlap="true">

                                  <template v-slot:badge>

                                      <v-icon v-if="filtrevarmi" large color="green">

                                          check_circle_outline                 

                                      </v-icon>

                                  </template>

                                  <v-btn small="" @mouseenter="tooltip = true"

                                      @mouseleave="tooltip = false" ref="fab" @click="filtrele()"

                                      color="info" fab dark>

                                      <v-icon>filter_list</v-icon>

                                  </v-btn>

                                  <v-tooltip bottom="" :activator="el" v-model="tooltip">

                                      <span>{{ $t('Add-Search-Filter') }}</span>

                                  </v-tooltip>

                            </v-badge>

                        </v-layout>

                      </v-flex>

                    </v-layout>

                  </v-card>

                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>

                  <v-card flat class="white--text">

                    <v-card flat="">

                      <v-card-actions>

                        <v-layout row wrap>

                          <v-flex xs12 sm12>

                            <v-card flat>

                              <ReportTable
                                :headers="analysisReportHeaders"
                                :items="analysisReportItems"
                                storage-key="analizraporu_columns"
                                :loading="progress"
                                :has-searched="reportHasSearched"
                                :show-search="true"
                                :search-label="$t('Search')"
                                :show-frontend-export="true"
                                :export-title="$t('Analysis-Report')"
                                :export-meta-items="analysisExportMetaItems"
                                :export-summary-cards="analysisSummaryCards"
                                :rows-per-page-items="[20, 50, 100, 200, 500, 1000]"
                              ></ReportTable>

                            </v-card>

                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"

                            ma-2 xs12 sm12 md12>

                            <v-layout align-center="" justify-center="" fill-height="">

                              <span class="title grey--text font-weight-bold">

                                 {{ $t('General-Totals') }}

                              </span>

                            </v-layout>

                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"

                            xs12 sm12 md12>

                            <v-card flat class="grey--text">

                              <v-layout>

                                <v-flex xs2 sm2 md2>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="body-1 font-weight-bold">

                                      {{$t('Ticket')}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs2 sm2 md2>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="body-1 font-weight-bold">

                                      {{ $t('Tax-v2') }}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs2 sm2 md2>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="body-1 font-weight-bold">

                                      {{$t('Service')}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs2 sm2 md2>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="body-1 font-weight-bold">

                                      {{$t('Commission')}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                    <v-flex xs2 sm2 md2>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="body-1 font-weight-bold">

                                      {{ $t('Total') }}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs2 sm2 md1>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="body-1 font-weight-bold">

                                      {{ $t('Discount') }}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs2 sm2 md1>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="body-1 font-weight-bold">

                                      {{ $t('Additional-Discount') }}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs2 sm2 md2>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="body-1 font-weight-bold">

                                      {{$t('Net-Profit')}} </span>

                                  </v-layout>

                                </v-flex>

                              </v-layout>

                              <v-divider light></v-divider>

                              <v-layout>

                                <v-flex xs2 sm2 md2>

                                  <v-layout align-center="" justify-end="" fill-height="">

                                    <span class="caption font-weight-thin">

                                      {{genTop.Bilet | moneyformat}}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs2 sm2 md2>

                                  <v-layout align-center="" justify-end="" fill-height="">

                                    <span class="caption font-weight-thin">

                                      {{genTop.Vergi | moneyformat}}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs2 sm2 md2>

                                  <v-layout align-center="" justify-end="" fill-height="">

                                    <span class="caption font-weight-thin">

                                      {{genTop.Servis | moneyformat}}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs2 sm2 md2>

                                  <v-layout align-center="" justify-end="" fill-height="">

                                    <span class="caption font-weight-thin">

                                      {{genTop.Komisyon | moneyformat}}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>



                                <v-flex xs2 sm2 md2>

                                  <v-layout align-center="" justify-end="" fill-height="">

                                    <span class="caption font-weight-thin">

                                      {{genTop.Toplam | moneyformat}}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs2 sm2 md1>

                                  <v-layout align-center="" justify-end="" fill-height="">

                                    <span class="caption font-weight-thin">

                                      {{genTop.Iskonto | moneyformat}}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs2 sm2 md1>

                                  <v-layout align-center="" justify-end="" fill-height="">

                                    <span class="caption font-weight-thin">

                                      {{genTop.EkIndirim | moneyformat}}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs2 sm2 md2>

                                  <v-layout align-center="" justify-end="" fill-height="">

                                    <span class="caption font-weight-thin">

                                      {{genTop.NetKar | moneyformat}}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                              </v-layout>

                              <v-divider light></v-divider>

                            </v-card>

                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>

                            <v-card class="grey--text">

                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <v-chip color="green"> <span class="subheading white--text">  {{ $t('General-Totals') }}

                                      </span>

                                    </v-chip>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading grey--text font-weight-bold"> {{$t('Ticket')}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading font-weight-">

                                      {{genTop.Bilet | moneyformat}}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading grey--text font-weight-bold"> {{$t('Tax-v2')}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading font-weight-">

                                      {{genTop.Vergi | moneyformat}}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading grey--text font-weight-bold"> {{$t('Service')}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading font-weight-">

                                      {{genTop.Servis | moneyformat}}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading grey--text font-weight-bold"> {{$t('Commission')}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading font-weight-">

                               {{genTop.Komisyon | moneyformat}}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading grey--text font-weight-bold"> {{$t('Total')}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading font-weight-">

                                    {{genTop.Toplam | moneyformat}}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading grey--text font-weight-bold"> {{ $t('Discount') }}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading font-weight-">

                                      {{genTop.Iskonto | moneyformat}}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                       <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading grey--text font-weight-bold"> {{ $t('Additional-Discount') }}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading font-weight-">

                                      {{genTop.EkIndirim | moneyformat}}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                       <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading grey--text font-weight-bold"> NetKar

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading font-weight-">

                                      {{genTop.NetKar | moneyformat}}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>







                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                              </v-layout>

                            </v-card>

                          </v-flex>

                        </v-layout>

                      </v-card-actions>

                    </v-card>

                  </v-card>

                </v-flex>



              </v-layout>

            </v-form>

          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"

            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">

            {{ text1 }}

            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>

          </v-snackbar>





          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">

            <v-card color="grey lighten-5">

              <v-card-title> {{ $t('Filter-selection') }} </v-card-title>

              <v-divider></v-divider>

              <v-card-text>

                <v-layout row="" wrap="">

                  <v-flex xs12 sm12 md12 pa-1>

                    <v-card class="white--text">

                      <v-card color="grey lighten-5" flat="">

                        <v-card-actions>

                          <v-layout row="" wrap="">





                            <v-flex xs12 sm12 md12>

                              <havayollaricomp :etiket="$t('Airline-Code')" v-model="havayolubil"></havayollaricomp>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                                   <cariaracomp v-bind:etiket="$t('Currentcode_label')" v-bind:value="Rapor.CariKod"

                                  v-model="Rapor.CariKod" :Coper="false"></cariaracomp>

                            </v-flex>



                            <v-flex xs12 sm12 md12>

                              <v-radio-group hide-details v-model="Rapor.AnalizTipi">

                                <v-radio value="0" :label="$t('All')"></v-radio>

                                <v-radio value="1" :label="$t('Analysis-Code')"></v-radio>

                                <v-radio value="2" :label="$t('Only-Analysis-Code')"></v-radio>

                              </v-radio-group>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-checkbox v-model="Rapor.MusteriToplamli" :label="$t('Show-Customer-Total')"

                                hide-details="">

                              </v-checkbox>

                            </v-flex>

                             <v-flex xs12 sm12 md12>

                            <v-layout justify-space-between column>

                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>

                            </v-layout>

                          </v-flex>

                          </v-layout>

                        </v-card-actions>

                      </v-card>

                    </v-card>

                  </v-flex>





                </v-layout>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>

                <v-spacer></v-spacer>

                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>

                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>

              </v-card-actions>

            </v-card>

          </v-dialog>

        </v-layout>

      </v-card>

    </v-app>

  </div>

</template>



<script>

  import auth from '../../../api/auth'

  import tarihcomp from '../customcomp/tarihim'

  import helpers from "@/components/app/customcomp/helpers.js"

  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"

  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"

  import analizcomp from "@/components/app/bilet/partpage/analizcomp.vue"

  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"

  import cariaracomp from '@/components/app/customcomp/cariaracomp'
  import ReportTable from '@/components/app/customcomp/ReportTable.vue'

  export default {

    data() {

      return {

        mailDialog: false,

                mailValid: false,

                mailLoading: false,

                mailPayload: {

                  To: "",

                  AgencyName: "",

                  DocType: "Analiz Raporu - Analysis Report", 

                  AgentFullName: "",

                  CustomBody: ""

                },

                rules: {

                  required: v => !!v || 'Zorunlu alan',

                  email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'

                },

        PB:'TRY',

          sayfayetki: {

          Screen: false,

          Update: false,

          Save: false,

          Delete: false,

          Status: false,

          Message: null,

          islem: 0,

        },

        filtrevarmi:false,
        reportHasSearched: false,

        havayolubil: {

          havayolukodu: null,

          formno: null

        },

        referansitems: [],

        evraktipi: [],

        search: '',

        searchsatilanbilet: null,

        searchiadebilet: null,

        searchvoid: null,





        genTop: {

          Bilet: 0,

          EkIndirim: 0,

          Iskonto: 0,

          Komisyon: 0,

          NetKar: 0,

          Servis: 0,

          Toplam: 0,

          Vergi: 0,

        },



        Rapor: {

          SirketKodu: null,

          AnalizKodu: null,

          BaslangicTarih: null,

          BitisTarih: null,

          CariKod: null,

          HavayoluKod: null,

          AnalizTipi: '0', // 0 :  Hepsi, 1 : Analiz Kodu, 2 : Sadece AnalizKodu 1

          MusteriToplamli: false

        },

        valid: true,

        tumsirketler: '',

        loading: false,

        items: [],

        load: false,

        load1: true,

        search3: '',

        renk1: 'info',

        dialogfiltre: false,

        hesapkodu: [],

        kredikarti: [],

        statecari: [],

        searchcari: '',

        progress: false,

        tooltip: false,

        el: null,

        yok: false,

        itemssatis: [],

        itemsiade: [],

        butondurum: true,

        snackbar: false,

        y: 'top',

        x: 'right',

        mode: '',

        timeout: 6000,

        text1: '',

        dictionary: {

          custom: {

            tarihsec: {

              required: () => this.$t('Please-select-a-date')

            },

            tarihsec1: {

              required: () => this.$t('Please-select-a-date')

            },

          }

        },

      }

    },

    beforeRouteEnter(to, from, next) {

      next(vm => {

        vm.prevRoute = from.path

      })

    },

    beforeMount: beforeMount,

    mounted() {

      this.$validator.localize('en', this.dictionary)

      this.el = this.$refs.fab.$el

       this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.PB=credentials.ParaBirimi

    var params3 = {

      CompanyCode: credentials.SirketKodu

    }

    // this.$http.post(auth.API_URL + 'api/Reference/List', params3, {

    //   headers: {

    //     'Authorization': 'Bearer ' + auth.getAuthHeader()

    //   }

    // }).then((response) => {

    //   this.referansitems = response.body

    // }, (response) => {

    //   if (response.status === 0) {

    //     this.text1 = 'Service Unavailable'

    //     this.snackbar = true

    //   } else {

    //     this.text1 = 'Service Unavailable'

    //     this.snackbar = true

    //   }

    // })



    this.$http.post(auth.API_URL + 'api/doctype/List', params3, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.evraktipi = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = 'Service Unavailable'

        this.snackbar = true

      } else {

        this.text1 = 'Service Unavailable'

        this.snackbar = true

      }

    })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {

              let url = '#' + this.prevRoute

              window.open(url, '_self')

            } else {

              let url = '#/'

              window.open(url, '_self')

            }

          } 

        });

      }

    },

    filters: {

      dateformat: function (t) {

        return helpers.dateformat(t);

      },

      moneyformat: function (m) {

        return helpers.moneyformat(m);

      },

      bakiyekontrol: function (m) {

        return helpers.bakiyekontrol(m);

      }

    },

    components: {

      'tarihcomp': tarihcomp,

      referansmerkezicomp,

      analizcomp,

      havayollaricomp,

      yetkidialog,

      cariaracomp,
      ReportTable

    },

    watch: {

    },

    methods: {

  openMailDialog() {

    if (this.$refs.mailForm && this.$refs.mailForm.resetValidation) {

      this.$refs.mailForm.resetValidation();

    }

    const pageDocType = "Analiz Raporu - Analysis Report";

    if (!this.mailPayload.DocType || this.mailPayload.DocType !== pageDocType) {

      this.mailPayload.DocType = pageDocType;

    }

    this.mailDialog = true;

  },

  closeMailDialog() {

    this.mailDialog = false;

  },

  sendMail() {

    const _this = this;

    if (!(_this.$refs && _this.$refs.mailForm && _this.$refs.mailForm.validate && _this.$refs.mailForm.validate())) {

      return;

    }

    const bas = (_this.Rapor && _this.Rapor.BaslangicTarih) ? new Date(_this.Rapor.BaslangicTarih) : null;

    const bit = (_this.Rapor && _this.Rapor.BitisTarih) ? new Date(_this.Rapor.BitisTarih) : null;

    if (!(bas && bit) || bas > bit) {

      _this.text1 = _this.$t('start-date-cannot-greater-than-end-date');

      _this.snackbar = true;

      return;

    }

    const credentialsRaw = window.localStorage.getItem('credentials');

    const credentials = credentialsRaw ? JSON.parse(credentialsRaw) : {};

    const companyCode = _this.tumsirketler === true

      ? '0'

      : (credentials && credentials.SirketKodu) ? credentials.SirketKodu : null;

    const havayoluKod = (_this.havayolubil && _this.havayolubil.havayolukodu) ? _this.havayolubil.havayolukodu : null;

    const inputObj = {

      SirketKodu: companyCode,

      AnalizKodu: _this.Rapor ? _this.Rapor.AnalizKodu : null,

      BaslangicTarih: _this.Rapor ? _this.Rapor.BaslangicTarih : null,

      BitisTarih: _this.Rapor ? _this.Rapor.BitisTarih : null,

      CariKod: _this.Rapor ? _this.Rapor.CariKod : null,

      HavayoluKod: havayoluKod,

      AnalizTipi: _this.Rapor ? _this.Rapor.AnalizTipi : '0',      

      MusteriToplamli: !!(_this.Rapor && _this.Rapor.MusteriToplamli)

    };

    const mailObj = {

      To: (_this.mailPayload && _this.mailPayload.To) ? _this.mailPayload.To : "",

      AgencyName: (_this.mailPayload && _this.mailPayload.AgencyName) ? _this.mailPayload.AgencyName : "",

      DocType: (_this.mailPayload && _this.mailPayload.DocType) ? _this.mailPayload.DocType : "Analiz Raporu - Analysis Report",

      AgentFullName: (_this.mailPayload && _this.mailPayload.AgentFullName) ? _this.mailPayload.AgentFullName : "",

      CustomBody: (_this.mailPayload && _this.mailPayload.CustomBody) ? _this.mailPayload.CustomBody : ""

    };

    const payload = {

      Input: inputObj,

      Mail: mailObj

    };

    _this.mailLoading = true;

    const endpoint = auth.API_URL + 'api/TicketReport/MailGonderAnalizRaporuExcel';

    _this.$http.post(

      endpoint,

      payload,

      { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }

    ).then(function () {

      _this.mailLoading = false;

      _this.mailDialog = false;

      _this.text1 = 'Mail gönderildi.';

      _this.snackbar = true;

    }, function (err) {

      _this.mailLoading = false;

      const body = (err && (err.body || err.data)) ? (err.body || err.data) : {};

      const msg = (body && (body.Message || body.message)) || err.statusText || 'Mail gönderilemedi.';

      _this.text1 = msg;

      _this.snackbar = true;

    });

  },



      getparabirimi() {

        return helpers.getparabirimi()

      },

      getList: getList,

      getListHtml: getListHtml,

      getListExcel: getListExcel,

      filtrele: filtrele,

      filtrekayit: filtrekayit,

      filtreiptal: filtreiptal

    },

    computed:{
      analysisReportHeaders() {
        var moneyFields=['Bilet','Vergi','Servis','Komisyon','Iskonto','Toplam','EkIndirim','NetKar'];
        return (this.headerssatis || []).map(function(header){
          var item=Object.assign({},header);
          if(moneyFields.indexOf(item.value)!==-1){ item.value='_'+item.value; item.type='money'; item.align='right'; }
          else if(item.value==='Tarih'){ item.type='date'; item.align='left'; }
          else { item.type='text'; item.align='left'; }
          item.visible=true; item.sortable=true; return item;
        });
      },
      analysisReportItems() {
        return (this.itemssatis || []).map(function(item){
          var row=Object.assign({},item), totals=item && item.Tutarlar ? item.Tutarlar : {};
          Object.keys(totals).forEach(function(key){ row['_'+key]=totals[key]; });
          return row;
        });
      },
      analysisExportMetaItems() {
        var analysisTypeMap={'0':this.$t('All'),'1':this.$t('Analysis-Code'),'2':this.$t('Only-Analysis-Code')};
        return [
          {label:this.$t('Starting-Date'),value:this.Rapor.BaslangicTarih,type:'date'},
          {label:this.$t('Finishing-Date'),value:this.Rapor.BitisTarih,type:'date'},
          {label:this.$t('Analysis-Code'),value:this.Rapor.AnalizKodu||''},
          {label:this.$t('Currentcode_label'),value:this.Rapor.CariKod||''},
          {label:this.$t('Airline-Code'),value:this.havayolubil&&this.havayolubil.havayolukodu?this.havayolubil.havayolukodu:''},
          {label:this.$t('Report-Type'),value:analysisTypeMap[String(this.Rapor.AnalizTipi)]||''},
          {label:this.$t('Show-Customer-Total'),value:this.Rapor.MusteriToplamli?'Evet':'Hayır'},
          {label:this.$t('All-Companies'),value:this.tumsirketler===true?'Evet':'Hayır'}
        ];
      },
      analysisSummaryCards() {
        var t=this.genTop||{};
        return [{title:this.$t('General-Totals'),items:[
          {label:this.$t('Ticket'),value:t.Bilet||0,type:'money'},
          {label:this.$t('Tax-v2'),value:t.Vergi||0,type:'money'},
          {label:this.$t('Service'),value:t.Servis||0,type:'money'},
          {label:this.$t('Commission'),value:t.Komisyon||0,type:'money'},
          {label:this.$t('Discount'),value:t.Iskonto||0,type:'money'},
          {label:this.$t('Total'),value:t.Toplam||0,type:'money'},
          {label:this.$t('Additional-Discount'),value:t.EkIndirim||0,type:'money'},
          {label:this.$t('Net-Profit'),value:t.NetKar||0,type:'money'}
        ]}];
      },

      headerssatis(){

          return [{

            text: this.$t('Ticket-No'),

            value: 'BiletNo'

          },

          {

            text: this.$t('Customer-Code'),

            value: 'CariKod',

          },

          {

            text: this.$t('Date'),

            value: 'Tarih'

          },

          {

            text: this.$t('Ticket'),

            value: 'Bilet'

          },

          {

            text: this.$t('Tax-v2'),

            value: 'Vergi'

          },

          {

            text: this.$t('Service'),

            value: 'Servis'

          },

          {

            text: this.$t('Commission'),

            value: 'Komisyon'

          },

          {

            text: this.$t('Discount'),

            value: 'Iskonto'

          },

          {

            text: this.$t('Total'),

            value: 'Toplam'

          },

          {

            text: this.$t('Additional-Discount'),

            value: 'EkIndirim'

          },

          {

            text: this.$t('Net-Profit'),

            value: 'NetKar'

          }

        ]

        },

    }

  }



  function filtrele() {

    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {

      CompanyCode: credentials.SirketKodu

    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.itemsairlinelist = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = 'Service Unavailable'

        this.progress = false

        this.snackbar = true

      } else {

        this.text1 = 'Service Unavailable'

        this.progress = false

        this.snackbar = true

      }

    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.hesapgurubu = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = 'Service Unavailable'

        this.snackbar = true

      } else {

        this.text1 = 'Service Unavailable'

        this.snackbar = true

      }

    })

    this.$http.post(auth.API_URL + 'api/currency/List', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.doviztipi = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = 'Service Unavailable-Döviz'

        this.snackbar = true

      } else {

        this.text1 = 'Service Unavailable-Döviz'

        this.snackbar = true

      }

    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.masrafmerkezi = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = 'Service Unavailable-ExpenseCenter'

        this.snackbar = true

      } else {

        this.text1 = 'Service Unavailable-ExpenseCenter'

        this.snackbar = true

      }

    })



  }







  function filtrekayit() {

    this.filtrevarmi=true

    this.dialogfiltre = false

    this.getList()

  }

  function filtreiptal() {

    this.filtrevarmi=false

    this.dialogfiltre = false







    this.Rapor.SirketKodu = null

    this.Rapor.AnalizKodu = null

    this.Rapor.CariKod = null

    this.Rapor.HavayoluKod = null

    this.havayolubil.havayolukodu = null

    this.Rapor.AnalizTipi = '0' // 0 :  Hepsi, 1 : Analiz Kodu, 2 : Sadece AnalizKodu 1

    this.Rapor.MusteriToplamli = false

    this.tumsirketler = ''

  }

  function getList() {

    if (this.$refs.formgunluksatis.validate()) {
      this.reportHasSearched = true



      var bastarih = new Date(this.Rapor.BaslangicTarih)

      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true

        this.load1 = false





        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.Rapor.HavayoluKod = this.havayolubil.havayolukodu

        if (this.tumsirketler === true) {

          this.Rapor.SirketKodu = '0'

        } else {

          this.Rapor.SirketKodu = credentials.SirketKodu

        }



        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/TicketReport/AnalyseReport', params, {

          headers: {

            'Authorization': 'Bearer ' + auth.getAuthHeader()

          }

        }).then((response) => {

          this.itemssatis = response.body.BiletListe

          this.genTop= response.body.GenelToplamlar

          this.progress = false

          this.load1 = true

        }, (response) => {

          if (response.status === 0) {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

          } else {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

          }

        })

      } else {

        this.text1 = this.$t('start-date-cannot-greater-than-end-date')

        this.snackbar = true

      }

    }

  }





  function getListHtml() {

    if (this.$refs.formgunluksatis.validate()) {



      var bastarih = new Date(this.Rapor.BaslangicTarih)

      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true

        this.load1 = false





        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var lang = localStorage.getItem('lang')

        this.Rapor.HavayoluKod = this.havayolubil.havayolukodu

        if (this.tumsirketler === true) {

          this.Rapor.SirketKodu = '0'

        } else {

          this.Rapor.SirketKodu = credentials.SirketKodu

        }



        var params = this.Rapor

     this.$http

      .post(auth.API_URL + "api/TicketReport/AnalyseReportHtml", params, {

        headers: {

          Authorization: "Bearer " + auth.getAuthHeader()

        }

      }).then((response) => {

        this.progress = false

        this.load1 = true

        if (lang=='en')

          {

             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);

             bodyhtml=bodyhtml.toString().replace('<title>ANALİZ RAPORU</title>','<title> Analysis REPORT </title>');

             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>ANALİZ RAPORU</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>Analysis REPORT</font>")

             bodyhtml=bodyhtml.toString().replace("İÇ HAT DAĞILIM RAPORU","DOMESTIC DISTRIBUTION REPORT")

             bodyhtml=bodyhtml.toString().replace("DIŞ HAT DAĞILIM RAPORU","INTERNATIONAL DISTRIBUTION REPORT")

             bodyhtml=bodyhtml.toString().replace("HY Kodu","Airline")

             bodyhtml=bodyhtml.toString().replace("Bilet No","Ticket No")

             bodyhtml=bodyhtml.toString().replace("Uçuş Type","Flight Type")

             bodyhtml=bodyhtml.toString().replace("Yolcu Name","Passenger Name")

             bodyhtml=bodyhtml.toString().replace("Void Tarihi","Void Date")

             bodyhtml=bodyhtml.toString().replace("Satış Tarihi","Sales Date")

             bodyhtml=bodyhtml.toString().replace("Kesim Tarihi","Cutting Date")

             bodyhtml=bodyhtml.toString().replace("Bilet Amountı","Ticket Amount")

             bodyhtml=bodyhtml.toString().replace("Vergi Tutarı","Tax Amount")

             bodyhtml=bodyhtml.toString().replace("Discount Tutarı","Discount Amount")

             bodyhtml=bodyhtml.toString().replace("Havayolu :","Airline :")

             bodyhtml=bodyhtml.toString().replaceAll("Havayolu","Airline")

             bodyhtml=bodyhtml.toString().replaceAll("Satış","Sales")

             bodyhtml=bodyhtml.toString().replaceAll("Iade","Refund")

             bodyhtml=bodyhtml.toString().replaceAll("Current Kodu","Current Code")

             bodyhtml=bodyhtml.toString().replaceAll("Net Satış","Net Sales")

             bodyhtml=bodyhtml.toString().replaceAll("Total Servis","Total Service")

             bodyhtml=bodyhtml.toString().replaceAll("Toplam Komisyon","Total Commision")

             bodyhtml=bodyhtml.toString().replaceAll("Total Komisyon","Total Commision")

             bodyhtml=bodyhtml.toString().replaceAll("Net Iskonto","Net Discount")

             bodyhtml=bodyhtml.toString().replaceAll("Net Kar","Net Profit")

             bodyhtml=bodyhtml.toString().replaceAll("Kar %","Profit %")

             bodyhtml=bodyhtml.toString().replaceAll("Vergi","Vat")

             bodyhtml=bodyhtml.toString().replaceAll("Bilet","Ticket")

             bodyhtml=bodyhtml.toString().replaceAll("Dış Hat Toplam :","International Line Total:")

             bodyhtml=bodyhtml.toString().replaceAll("İç Hat Toplam :","Domestic Line Total:")

             bodyhtml=bodyhtml.toString().replaceAll("TOPLAM :","TOTAL :")

             response.bodyText=bodyhtml;

          }

        var blob = new Blob([response.bodyText], {

          type: 'application/html'

        });

        var link = document.createElement('a');

        link.href = window.URL.createObjectURL(blob);

        link.download = "AnalysisReport.html";

        link.click();

      }, (response) => {

        if (response.status === 0) {

          this.text1 = 'Service Unavailable'

          this.snackbar = true

          this.progress = false

          this.load1 = true

        } else {

          this.text1 = 'Service Unavailable'

          this.snackbar = true

          this.progress = false

          this.load1 = true

        }

      })

      } else {

        this.text1 = this.$t('start-date-cannot-greater-than-end-date')

        this.snackbar = true

      }

    }

  }



  function getListExcel() {

    if (this.$refs.formgunluksatis.validate()) {



      var bastarih = new Date(this.Rapor.BaslangicTarih)

      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true

        this.load1 = false





        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.Rapor.HavayoluKod = this.havayolubil.havayolukodu

        if (this.tumsirketler === true) {

          this.Rapor.SirketKodu = '0'

        } else {

          this.Rapor.SirketKodu = credentials.SirketKodu

        }



        var params = this.Rapor

     this.$http

      .post(auth.API_URL + "api/TicketReport/AnalyseReportExcel", params, {

        headers: {

          Authorization: "Bearer " + auth.getAuthHeader()

           },

          responseType: "arraybuffer"

      }).then((response) => {

        this.progress = false

        this.load1 = true

        var blob = new Blob([response.data], {

          type: 'application/xlsx'

        });

        var link = document.createElement('a');

        link.href = window.URL.createObjectURL(blob);

        link.download = "AnalysisReport.xlsx";

        link.click();

      }, (response) => {

        if (response.status === 0) {

          this.text1 = 'Service Unavailable'

          this.snackbar = true

          this.progress = false

          this.load1 = true

        } else {

          this.text1 = 'Service Unavailable'

          this.snackbar = true

          this.progress = false

          this.load1 = true

        }

      })

      } else {

        this.text1 = this.$t('start-date-cannot-greater-than-end-date')

        this.snackbar = true

      }

    }

  }



  function beforeMount() {





  }

</script>

<style scoped>

</style>